import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Prompt, Redirect } from 'react-router-dom';

import Modal from '../index';

import { ModalContent } from './styles';

const PreventExitModal = ({ cantExit, onClickPrimaryButton }) => {
  const { t } = useTranslation();

  const [loadingButton, setLoadingButton] = useState(false);

  const [openExitModal, setOpenExitModal] = useState(false);
  const [shouldExit, setShouldExit] = useState(false);
  const exitLocation = useRef(null);

  return (
    <>
      <Prompt
        when={cantExit}
        message={(location) => {
          if (shouldExit) {
            return true;
          }
          exitLocation.current = `${location.pathname}${location.search}`;
          setOpenExitModal(true);
          return false;
        }}
      />

      {shouldExit && <Redirect to={exitLocation.current} />}

      <Modal
        content={<ModalContent>{t('components.preventExitModal.modalContentText')}</ModalContent>}
        open={openExitModal}
        labelPrimaryButton={t('common.save')}
        labelSecondaryButton={t('common.exit')}
        loadingPrimaryButton={loadingButton}
        loadingLabelPrimaryButton={t('common.saving')}
        onClickPrimaryButton={async () => {
          setLoadingButton(true);
          await onClickPrimaryButton();
          setOpenExitModal(false);
          setShouldExit(true);
        }}
        onClickSecondaryButton={() => {
          setOpenExitModal(false);
          setShouldExit(true);
        }}
      />
    </>
  );
};

PreventExitModal.propTypes = {
  cantExit: PropTypes.bool.isRequired,
  onClickPrimaryButton: PropTypes.func.isRequired,
};

export default PreventExitModal;
